import {
    AfterViewChecked,
    AfterViewInit,
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    Output
} from '@angular/core';
import { TimerService } from '../../Utilities';

@Directive({
    selector: '[infiniteScroll]',
    standalone: false
})
export class InfiniteScrollDirective implements AfterViewInit, AfterViewChecked, OnDestroy {
    constructor(private _el: ElementRef,
                private _timer: TimerService) { }

    @Input() set infiniteScrollTargetClass(className: string) {
        this._targetClass = `${className.startsWith('.') || '.'}${className}`;
        this._timer.setTimeout(this._setTargetElement.bind(this));
    };

    @Output() infiniteScrollNext: EventEmitter<void> = new EventEmitter<void>();

    private _targetClass: string;
    private _observer: IntersectionObserver;
    private _currentTarget: HTMLElement;
    private _mostRecentEntryRequest: Element;

    ngAfterViewInit(): void {
        const options: IntersectionObserverInit = {
            root: this._el.nativeElement,
            rootMargin: '0px',
            threshold: 0.5,
        };
        this._observer = new IntersectionObserver((entries) => {
            // Trigger when element is intersecting,
            // is not visible without scrolling,
            // and that it hasn't already been requested
            if (entries[0].isIntersecting
                && this._el.nativeElement.scrollTop > 0
                && this._mostRecentEntryRequest !== entries[0].target) {
                this._mostRecentEntryRequest = entries[0].target;
                this.infiniteScrollNext.emit();
            }
        }, options);

        this._setTargetElement();
    }

    ngAfterViewChecked(): void {
        const lastElementNodes = this._el.nativeElement.querySelectorAll(this._targetClass);
        const lastElementInList = (Array.from(lastElementNodes) as HTMLElement[]).pop();

        if (this._currentTarget !== lastElementInList) {
            this._setTargetElement(lastElementInList);
        }
    }

    ngOnDestroy(): void {
        this._observer.disconnect();
        this._currentTarget = null;
    }

    private _setTargetElement(lastElementInList?: HTMLElement): void {
        if (!this._observer) {
            return;
        }

        if (!lastElementInList) {
            const lastElementNodes = this._el.nativeElement.querySelectorAll(this._targetClass);
            lastElementInList = (Array.from(lastElementNodes) as HTMLElement[]).pop();
        }

        if (lastElementInList) {
            if (this._currentTarget) {
                this._observer.unobserve(this._currentTarget);
                this._mostRecentEntryRequest = null;
            }
            this._observer.observe(lastElementInList);
            this._currentTarget = lastElementInList;
        }
    }
}
